<template lang="pug">
    form-group-layout.textarea-field(:label='label' v-bind='$attrs')
        template(v-slot='{invalid, errors, touch, delayedTouch}')
            label.textarea-field__label(v-if='!hideLabel && label') {{ label }}
                tooltip-control(v-if='tooltip' :tooltip='tooltip')

            div.textarea-field__wrap
                textarea.form-control(v-model='model' :class='fieldClass'
                        :invalid='invalid' :placeholder='placeholder' :disabled='disabled'
                        @input='delayedTouch' @blur='touch' @change='onChange'
                        ref='field')

                char-limit-warning(v-if='ready && limit' :limit='limit' :text='model' :field='$refs.field')

                slot(name="controls" v-if="$refs.field" :field="$refs.field")

            inline-error-control(:errors='errors' :relative='true')
</template>

<script>
export default {
    name: 'textarea-field',
    props: {
        value: String,
        label: String,
        hideLabel: Boolean,
        placeholder: String,
        disabled: Boolean,
        tooltip: String,
        limit: {
            default: 0,
            type: Number,
        },
    },
    data() {
        return {
            modelValue: null,
            ready: false,
        }
    },
    computed:{
        model:{
            get() {
                return this.modelValue
            },
            set(val) {
                this.modelValue = val
                this.$emit('input', val)
            },
        },
        fieldClass() {
            return {
                'char-limit-warning-field': this.limit > 0,
            }
        },
    },
    watch: {
        value: {
            handler(val) {
                this.modelValue = val
            },
            immediate: true,
        },
    },
    methods: {
        onChange(val) {
            this.$emit('change', val)
        },
    },
    mounted() {
        this.ready = true
    },
}
</script>
